import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Icon} from 'front-onceforall-core';

import moment from 'moment-timezone';

const MAX_DAYS = 7;

function ResendButton(props) {
  const diffDays = moment().diff(moment(props.invitation.lastSentDate), 'days');
  const text = I18n.t('client.invitations.actions.resend');
  const button = (
    <button
      type="button"
      className="small secondary no-wrap inline-container"
      data-id="clientInvitationsButtonResend"
      onClick={props.invitation.resendable ? props.onResendInvitation : () => {}}
      title={text}
      disabled={!props.invitation.resendable || props.loading}
    >
      <Icon icon={props.loading ? 'loader' : 'paper-plane'}/>
      <span className="d-none d-lg-block">
        {text}
      </span>
    </button>
  );
  return props.invitation.resendable ? button :
    (<span
      tooltip={I18n.t('client.invitations.actions.tooltip', {count: MAX_DAYS - diffDays})}
      flow="left"
    >
      {button}
    </span>
    );
}

ResendButton.propTypes = {
  invitation: PropTypes.object.isRequired,
  onResendInvitation: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ResendButton;
